const QUERIES = {
  USERS_LIST: "users-list",
  TRANSFERS_LIST: "transfers-list",
  TRANSACTION_HISTORY_LIST: "transaction-history-list",
  REFUNDS_LIST: "refunds-list",
  USER_FUNDS_LIST: "funds-list",
  CHECK_USER_FUNDS_LIST: "check-funds-list",
  COMMONS: "commons",
};

export { QUERIES };
